import { formatNumber } from '@dec/shared';
import {
  CurrencyDollar,
  DoorClosed,
  DoorOpen,
  FileSpreadsheet,
  Hourglass,
  People,
  Percent
} from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import { useGetStatistics } from '../hooks';

import Indicator from './Indicator';

export const ContainerStatistics = ({ search }: { search: any }) => {
  const { t } = useTranslation();
  const [{ data, loading, error }] = useGetStatistics(search);

  if (loading || error) {
    return <></>;
  }

  const labelCountTaxpayerNotified = t('non-compliances.label.countTaxpayerNotified');
  const labelCountEndedProcess = t('collections.label.countEndedProcess');
  const labelCountInProgressProcess = t('collections.label.countInProgressProcess');
  const labelCounTaxpayer = t('collections.label.countTaxpayerProcess');

  const labelRecoveredDebt = t('collections.label.recoveredDebt');
  const labelOriginalDebt = t('collections.label.debtOriginal');
  //  const labelFinalDebt = t('collections.label.debtFinal');
  const labelCurrentDebt = t('collections.label.currentDebt');
  const labelTimeElapsed = t('collections.label.timeElapsed');
  const labelDays = t('non-compliances.label.days');

  if (data === undefined || (data as any) === '') {
    return (
      <>
        <div className="h-25">
          <div className="d-flex align-self-center align-items-center justify-content-center">
            <div>{t('common.label.noFound')}</div>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="card-group">
        <div className="row equal-height">
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={Infinity}
              title={labelCountTaxpayerNotified}
              value={data.countProcess}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={DoorOpen}
              title={labelCountInProgressProcess}
              value={data.countInProgressProcess}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={DoorClosed}
              title={labelCountEndedProcess}
              value={data.countEndedProcess}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator icon={People} title={labelCounTaxpayer} value={data.countTaxpayers} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={Percent}
              title={labelRecoveredDebt}
              value={`${data.recoveredDebt} %`}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={Hourglass}
              title={labelTimeElapsed}
              value={`${data.elapsedTime} ${labelDays}`}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={FileSpreadsheet}
              title={labelOriginalDebt}
              value={formatNumber(data.debtOriginal)}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={CurrencyDollar}
              title={labelCurrentDebt}
              value={formatNumber(data.debtFinal as number)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
